// GenerateTimesSchedules returns available starts in 30-minute blocks
// (apps/api/config/app.php: min_time_to_attend). The last selected start is inclusive.
const SLOT_MINUTES = 30;

export function isAvailableBookingRange(selection: string[], available: string[]): boolean {
  if (selection.length === 0 || selection.length > 2) return false;
  const minutes = (time: string) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));
  const selected = selection.map(minutes).sort((a, b) => a - b);
  const slots = new Set(available.map(minutes));
  const first = selected[0];
  const last = selected[selected.length - 1];
  if (!Number.isFinite(first) || !Number.isFinite(last) || (last - first) % SLOT_MINUTES !== 0) return false;
  for (let slot = first; slot <= last; slot += SLOT_MINUTES) {
    if (!slots.has(slot)) return false;
  }
  return true;
}
